export default function SupportHero() {
  const { t } = useTranslation();
  return (
    <section className="gradient-hero pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white mb-8">{t('support.hero_title')}</h1>
        <div className="relative">
          <input type="text" placeholder={t('support.hero_placeholder')}
            className="w-full px-6 py-4 rounded-2xl text-white placeholder-white/40 text-sm focus:outline-none focus:ring-2 focus:ring-white/30"
            style={{ background: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.15)' }} />
          <button className="absolute right-3 top-1/2 -translate-y-1/2 bg-primary-500 hover:bg-primary-400 text-white px-5 py-2 rounded-xl text-sm font-semibold transition-colors">
            Axtar
          </button>
        </div>
      </div>
    </section>
  );
}
